import React from "react";
import Slider from "react-slick";
import PropTypes from "prop-types";

import "./styles.scss";

import { Container, Row, Col } from "reactstrap";

const Speakers = ({ speakers }) => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 4000,
        autoplay: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 560,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };

    return (
        <Container fluid tag="section" className="speakers py-5">
            <Row>
                <Col xs="12" className="text-center">
                    <h2 className="title">Principales ponentes</h2>
                </Col>
                <Col className="pt-5">
                    <Slider {...settings}>
                        {speakers.map((speaker, i) => (
                            <div key={i} className="speaker px-5">
                                <img src={`/images/ponentes/${speaker.image}.jpg`} alt={speaker.name} title={speaker.name} className="img-fluid" />
                                <h4>{speaker.name}</h4>
                                <p>{speaker.description}</p>
                            </div>
                        ))}
                    </Slider>
                </Col>
            </Row>
        </Container>
    );
};

Speakers.propTypes = {
    speakers: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default Speakers;